import React from 'react';
import { Layout, Button, Row, Col, Badge } from 'antd';
import { ShoppingCartOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import {Switch, Route, useRouteMatch,useLocation} from 'react-router-dom';
import Cookies from 'js-cookie';
const Cart = () => {
  const { shipments,fetchUser } = useSelector(state => {
    return {
      shipments: state.shipment.list,
      fetchUser: state.auth,
    };
  });
  const custId = fetchUser?.userId;
  const location = useLocation();
  const { pathname } = location;
  const pathArray = pathname.split("/");
  const check = pathArray.includes('create-shipment') || pathArray.includes('create-shipment_upload_2');
  const checkPageType = pathArray.includes('create-shipment') ? 'created' : 'upload';
  
  const [taxId, setTaxId] = React.useState('');
  React.useEffect(() => {
    Cookies.get('personal_number') ? setTaxId(()=>Cookies.get('personal_number')) : setTaxId('');
  }, [shipments,custId]);
  return shipments && (shipments.length >= 1 && shipments.length <= 99 ) && check ? (
    <Link to={`/admin/pages/cartshipments/${atob(taxId)}/${checkPageType}`}>
      <Badge count={shipments.length}>
        <ShoppingCartOutlined style={{ fontSize: '25px', cursor: 'pointer' }} />
      </Badge>
    </Link>
  ) : null;
};
export default Cart;
